<template>
	<div>
		<!-- <Layout :navFixed="true" :transparent="true" :background="require('@/assets/img/bg-products.jpg')"> -->
		<Layout :navFixed="true" :transparent="false" :withImage="true" :invert="true">
			<div class="container-fluid " style="margin-top:120px;padding-bottom:170px">
				<div class="container ">

					<div class="row row-xs only-desktop">
						<div class="col-12">
							<div class="category-bar">
								<div class="title">
									<h3 v-if="categorySelected">
										{{categorySelected.title}}
										<span v-if="subCategorySelected"> - {{subCategorySelected.title}}</span>
									</h3>
									<h3 v-else>
										Tienda online
									</h3>

									<div class="search-filter" v-if="filters.search">
										Filtrando resultados por: {{ filters.search }}

									</div>

								</div>
								<div>
									<b-dropdown  variant="link">
										<template #button-content>
											<svg class="ui-search-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
												<path
													d="M6.857 23.527l-3.705-3.705-1.616 1.616 6.464 6.464 6.464-6.462-1.616-1.616-3.705 3.701v-18.953h-2.286v18.955zM22.857 8.473l-3.705 3.705-1.616-1.616 6.464-6.464 0.809 0.807 5.655 5.657-1.616 1.616-3.705-3.703v18.953h-2.286v-18.955z"
												></path>
											</svg>
											Ordenar por:
										</template>
										<b-dropdown-item @click="
											filters.orderBy = 'PRICE_ASC'
											updateFilters()
										">
											Menor precio
										</b-dropdown-item>
										<b-dropdown-item @click="
											filters.orderBy = 'PRICE_DESC'
											updateFilters()
										">
											Mayor precio
										</b-dropdown-item>
									</b-dropdown>
								</div>
							</div>
						</div>
					</div>


					<div class="only-mobile">
						<div class="filters-bar ">
							<div class="btn" v-b-modal.modalFilterOrder>
								<svg class="ui-search-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M6.857 23.527l-3.705-3.705-1.616 1.616 6.464 6.464 6.464-6.462-1.616-1.616-3.705 3.701v-18.953h-2.286v18.955zM22.857 8.473l-3.705 3.705-1.616-1.616 6.464-6.464 0.809 0.807 5.655 5.657-1.616 1.616-3.705-3.703v18.953h-2.286v-18.955z"
									></path>
								</svg>
								Ordenar
							</div>
							<div class="btn" v-b-modal.modalFilterCategory>
								<svg class="ui-search-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M15.9 22h16.1v2h-16.1c-0.479 2.301-2.491 4.005-4.9 4.005s-4.42-1.704-4.894-3.973l-0.006-0.032h-6.1v-2h6.1c0.479-2.301 2.491-4.005 4.9-4.005s4.421 1.704 4.894 3.973l0.006 0.032zM18.1 8c0.48-2.301 2.491-4.005 4.9-4.005s4.421 1.704 4.894 3.973l0.006 0.032h4.1v2h-4.1c-0.48 2.301-2.491 4.005-4.9 4.005s-4.421-1.704-4.894-3.973l-0.006-0.033h-18.1v-2h18.1zM23 12c1.657 0 3-1.343 3-3s-1.343-3-3-3v0c-1.657 0-3 1.343-3 3s1.343 3 3 3v0zM11 26c1.657 0 3-1.343 3-3s-1.343-3-3-3v0c-1.657 0-3 1.343-3 3s1.343 3 3 3v0z"
									></path>
								</svg>
								Filtrar
							</div>
						</div>
					</div>



					<div class="row row-xs">
						<div class="col-12 ">
							<div class="product-list mt-2">
								<div class="sidebar only-desktop">
									<!-- <h3 class="mb-3 mt-2">Filtrar por categoría</h3> -->

									
									<div class="filter-list">
										<div v-for="category in categories" :key="category.id"   >
											<div @click="openCategory(category)" class="filter" :class="{ selected: categorySelected && category.id == categorySelected.id }">{{ category.title }}</div>
											<div class="subcategories" v-show="categoryOpened == category.id || ( categorySelected && categorySelected.id == category.id)">
												<router-link 
													v-for="subcategory in category.subCategories" 
													:key="subcategory.id" 
													class="filter"
													tag="a"
													:to="`/tienda/${category.slug}/${subcategory.slug}`"
													:class="{selected: subCategorySelected && subcategory.id == subCategorySelected.id}"
													>
													{{subcategory.title}}
												</router-link>
											</div>

										</div>
									</div>
								</div>

								<div class="content">
									<div class="row row-xs">

										
										<!-- <div class="col-12">
											<div class="category-bar">
												
												<h3 v-if="categorySelected">
													{{categorySelected.title}}
													<span v-if="subCategorySelected"> - {{subCategorySelected.title}}</span>
												</h3>
												<h3 v-else>
													Tienda online
												</h3>
												<div>
													<b-dropdown  variant="link">
														<template #button-content>
															<svg class="ui-search-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
																<path
																	d="M6.857 23.527l-3.705-3.705-1.616 1.616 6.464 6.464 6.464-6.462-1.616-1.616-3.705 3.701v-18.953h-2.286v18.955zM22.857 8.473l-3.705 3.705-1.616-1.616 6.464-6.464 0.809 0.807 5.655 5.657-1.616 1.616-3.705-3.703v18.953h-2.286v-18.955z"
																></path>
															</svg>
															Ordenar por:
														</template>
														<b-dropdown-item @click="
															filters.orderBy = 'PRICE_ASC'
															updateFilters()
														">
															Menor precio
														</b-dropdown-item>
														<b-dropdown-item @click="
															filters.orderBy = 'PRICE_DESC'
															updateFilters()
														">
															Mayor precio
														</b-dropdown-item>
													</b-dropdown>
												</div>
											</div>
										</div> -->
										

										<Loader :show="loading" type="inline"/>

										<div class="col-12 mt-5 mb-5 p-5 text-center" v-if="!loading && items.length == 0">
											No se han encontrado productos que conicidan con su búsqueda
										</div>

										<div class="col-12 col-md-6 col-lg-4" v-for="item in items" :key="item.id">
											<TiendaListItem :item="item" />
										</div>
										
										<div class="col-12">
											<Pagination :pageData="pagination" @pageChange="pageChange" />
										</div>

									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</Layout>

		<b-modal id="modalFilterCategory" hide-header hide-footer dialog-class="modal-fullscreen" scrollable centered>
			<div class="d-flex align-items-center pt-3 pb-3">
				<div @click="$bvModal.hide('modalFilterCategory')">
					<i class="icon icon-chevron-left mr-2"></i>
				</div>
				<h3 class="">Filtrar por categoría</h3>
			</div>
			<div class="filter-list">
				<router-link v-for="category in categories" :key="category.id" tag="a" :to="`/productos/${category.slug}`" class="filter" :class="{ selected: categorySelected && category.id == categorySelected.id }">
					{{ category.title }}
				</router-link>
			</div>
		</b-modal>

		<b-modal id="modalFilterOrder" hide-header hide-footer dialog-class="modal-fullscreen" scrollable centered>
			<div class="d-flex align-items-center pt-3 pb-3">
				<div @click="$bvModal.hide('modalFilterOrder')">
					<i class="icon icon-chevron-left mr-2"></i>
				</div>
				<h3 class="">Ordenar por</h3>
			</div>
			<div class="filter-list">
				<div
					class="filter"
					@click="
						filters.orderBy = 'PRICE_ASC'
						updateFilters()
					"
					:class="{ selected: filters.orderBy == 'PRICE_ASC' }"
				>
					Menor precio
				</div>
				<div
					class="filter"
					@click="
						filters.orderBy = 'PRICE_DESC'
						updateFilters()
					"
					:class="{ selected: filters.orderBy == 'PRICE_DESC' }"
				>
					Mayor precio
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import ecommerceMixins from '@/components/ecommerce/mixins'
import listMixins from '@/mixins/listMixins'
import Layout from '@/components/Layout'
import Loader from '@/components/Loader'
import TiendaListItem from '@/components/TiendaListItem'
import Pagination from '@/components/Pagination'

export default {
	name: 'Tienda',
	mixims: [ecommerceMixins, listMixins],
	components: {
		Layout,
		Loader,
		TiendaListItem,
		Pagination,
	},
	metaInfo() {
		return {
			title: this.categorySelected ? this.categorySelected.title : 'Accesorios',
		}
	},
	data() {
		return {
			loading: true,
			categories: [],
			categorySelected: null,
			subCategorySelected: null,
			categoryOpened: null,
			items: [],
			filters: null,
		}
	},
	async beforeMount() {
		this.filters = this.getValidUrlParams()
		await this.fetchData()
		this.load()
		if (this.$route.params.category) this.categorySelected = this.categories.find((c) => c.slug == this.$route.params.category)
		if (this.$route.params.subcategory) this.subCategorySelected = this.categorySelected.subCategories.find((c) => c.slug == this.$route.params.subcategory)
		//search query
		if (this.$route.query.search) {
			this.filters.search = this.$route.query.search
		}
	},
	methods: {
		openCategory(category){
			this.categoryOpened = category.id
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $status: String, $category: String,$subCategory: String, $orderBy: String, $featured:Boolean, $search:String) {
							products(take: $take, skip: $skip, status: $status, category: $category, subCategory: $subCategory, orderBy: $orderBy, featured: $featured, search:$search) {
								data {
									id
									name
									slug
									price
									priceWithoutTaxes
									image {
										id
										type
										filename
										url
										urlThumb
									}
									featured
									subCategory{
										id title
										category{id title}
									}
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						status: 'ACTIVE',
						category: this.$route.params.category ? this.$route.params.category : null,
						subCategory: this.$route.params.subcategory ? this.$route.params.subcategory : null,
						search: this.filters.search,
						orderBy: this.filters.orderBy,
						featured: this.$route.params.category || this.$route.params.subcategory ? false : true,
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.items = data.products.data
					this.pagination.pageInfo = data.products.pageInfo
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},

		fetchData() {
			return this.$apollo
				.query({
					query: gql`
						query($status: String) {
							categories(status: $status) {
								data {
									id
									title
									slug
									status
									subCategories {
										id
										title
										slug
										status
									}
								}
							}
						}
					`,
					variables: {
						status: 'ACTIVE',
					},
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.categories = data.categories.data
				})
				.catch((err) => {
					console.log(err)
				})
		},
	},
}
</script>

<style scoped lang="scss">
.category-bar{
	padding: 14px;
	margin-bottom: 8px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #e0e0e0;

	h3{

	}
	&::v-deep .btn{
		text-decoration: none !important;
		color: #333;
	}
}
.product-list {
	display: flex;

	.sidebar {
		flex-grow: 0;
		flex-shrink: 0;
		width: 240px;
		padding: 12px;
	}
	.content {
		flex-grow: 1;
	}
}
h3 {
	font-size: 18px;
	font-weight: 600;
}

.filter-list {
	display: flex;
	flex-direction: column;

	.subcategories{
		padding: 0px 0px 0px 16px;
		transition: all 0.3s ease-in-out;

		.filter{
			padding: 3px 8px;
			cursor: pointer;
			font-size: 14px;
			font-weight: 400;
		}
	}
	
	.filter {
		width: 100%;
		padding: 8px;
		font-size: 15px;
		font-weight: 500;
		cursor: pointer;
		display: block;
		font-weight: 600;
		
		&.selected {
			color: #2d63aa;
		}

		&:hover {
			color: #2d63aa;
			// background-color: #f3f3f3;
		}
	}
}

.filters-bar {
	display: flex;
	align-items: center;
	justify-content: space-around;
	border-bottom: 1px solid #dddddd;
	margin: 0px -15px;

	.btn {
		padding: 14px;
	}
}
.modal-fullscreen .filter-list .filter {
	padding: 12px 15px;
}

.ui-search-icon {
	width: 14px;
	height: 14px;
	fill: #333333;
}
</style>
